module.exports = __webpack_public_path__ + "img/esrlogo.e24410d6.png";